import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton";

function Options({ handleStep, data, setData }) {
  const [value, setValue] = useState({
    optionsList: data.optionsList,
    selectedList: data.selectedList,
    wholesalerIds: data.wholesalerlist,
    timeslot: data.time_slot,
    bonusFee: data.bonusFee,
  });

  const submitInfo = (action) => {
    handleStep(value, action, "list");
  };

  const handleClick = (data) => {
    let array = value.selectedList;
    if (array.includes(data)) {
      const index = array.indexOf(data);
      array.splice(index, 1);
      setValue({
        ...value,
        selectedList: array,
      });
    } else
      setValue({
        ...value,
        selectedList: [...value.selectedList, data],
      });
  };

  useEffect(() => {
    let i;
    let option = data.option;
    let fee = 0;
    for (i = 0; i < option.length; i++) {
      if (
        value.selectedList.includes(option[i].sponsors_bonus_option_id) &&
        option[i].is_collect_amount === "1"
      ) {
        fee = fee + parseInt(option[i].cost_fee, 10);
      }
    }
    setValue({
      ...value,
      bonusFee: fee,
    });
  }, [value.selectedList]);

  useEffect(() => {
    data.subType
      .filter((info) => info.registration_sub_type_id === data.selectedSubType)
      .map((val) =>
        setValue({
          ...value,
          optionsList: val.sponsors_benefit_list,
        })
      );
  }, []);

  useEffect(() => {
    setData({
      ...data,
      tempIds: [],
      eventIds: [],
      guestEventIds: [],
      sub_event_list: [],
      guest_sub_event_list: [],
      wholesalerlist: [],
    });
  }, []);

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-6 col-sm-6 col-12">
        <div className="glass-effect space">

          <form>
            <div className="form-inner">
              <div className="mb-10 form-label">Benefits included</div>
              <span className="textarea">
                {value.optionsList.map((val) => {
                  return (
                    <label className="textarea-content" disabled={true}>
                      {val.title}
                    </label>
                  );
                })}
              </span>
            </div>
            <div className="col-lg-12">
              <div className="form-inner">
                <div className="mb-10 form-label">Bonus Sponsorship Options: </div>
                <span className="textarea">
                  {data.option
                    .sort((a, b) => a.order_by - b.order_by)
                    .map((val) => {
                      return (
                        <label
                          style={{
                            backgroundColor:
                              value.selectedList.includes(val.sponsors_bonus_option_id)
                                ? "#2b5a55"
                                : "",
                            color:
                              value.selectedList.includes(val.sponsors_bonus_option_id)
                                ? "#fff"
                                : "",
                          }}
                          className="textarea-content-unselect"
                          disabled={true}
                          onClick={() =>
                            handleClick(val.sponsors_bonus_option_id)
                          }
                        >
                          {val.title} ( ${val.cost_fee} )
                        </label>
                      );
                    })}
                </span>
              </div>
            </div>
            <div className="arrow-container">
              <button className="eg-btn btn--primary2 capsule mt-20 prev" onClick={() => submitInfo("previous")} > 
                <CustomButton />Prev
              </button>

              <button className="eg-btn btn--primary2 capsule mt-20" onClick={() => submitInfo("next")}>
                Next<CustomButton />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Options;